module.exports = __webpack_public_path__ + "prod/1.42.2/img/logo_four2x.abada6ca.png";